import { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. Centralizamos el inicio de sesión
  const login = (userData) => {
    localStorage.setItem('token', userData.token);
    localStorage.setItem('rol', userData.rol);
    localStorage.setItem('nombre', userData.nombre);
    localStorage.setItem('id', userData.id); // Usamos 'id' que es lo que manda PHP
    setUser(userData);
  };

  useEffect(() => {
    const cargarSesion = () => {
      const token = localStorage.getItem('token');
      const rol = localStorage.getItem('rol');
      const nombre = localStorage.getItem('nombre');
      const id = localStorage.getItem('id');
    
      if (token && rol) {
        // Restauramos el estado global desde el localStorage
        setUser({ token, rol, nombre, id }); 
      }
      setLoading(false);
    };

    cargarSesion();
  }, []);

  const logout = () => {
    localStorage.clear();
    setUser(null);
    // Opcional: window.location.href = "/admin-intro"; // Para forzar limpieza total
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};